import { add } from 'date-fns';

/**
 * Returns the name of the month after the provided date
 * @param date - initial date
 * @returns {string} name of month after the initial date
 *
 * @example
 * getNextMonthName(new Date('07-15-2022'));
 * // 'August'
 */
var getNextMonthName = function getNextMonthName(date) {
  return add(date, {
    months: 1
  }).toLocaleString('default', {
    month: 'long'
  });
};
export default getNextMonthName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/date/getNextMonthName.js
// module id = 2850
// module chunks = 11